export enum SuzInternalStatus {
	Success = 1,
	Error,
	OperationNotExecuted,
    DeviceConnectionError,
    DeviceNotExistsError,
	DailyReportRequired,
	MappingError,
	DeviceError,
	InvalidCredentials
}
